module.exports = __webpack_public_path__ + "images/ds-cm2024-instructor-davis-balaba.webp";